import { useSpreadsheetDataEntityFiltersSelector } from '~/store/spreadsheetData/filtering/useSpreadsheetDataEntityFilters';
import { useWeightedCenterSelectedEntitiesSelector } from './weightedCenter.selectors';

export const useWeightedCenterFilter = () => {
  const spreadsheetPreviewFilterState = useWeightedCenterSelectedEntitiesSelector();

  return useSpreadsheetDataEntityFiltersSelector({
    filter: spreadsheetPreviewFilterState,
  });
};
